/*
* AGP events
* Menu
*/

import $ from "jquery";
import 'bootstrap';
import "../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js";

var menu = {};

menu.lateral = $("#menu-toggle");
menu._open = true;


export default class Menu {

    constructor(el) {
        this.DOM = {el: el};
    }

    init() {

        let _this = this;


        var $windowW = $(window).width();
        if ($windowW < 1455 || $("#wrapper").hasClass("toggled")) {
            $("#wrapper").addClass("toggled");
            menu._open = false;
            $(".open_sub").removeClass("activ");
            $(".sub_menu").removeAttr("style");
            $("#sidebar-wrapper").css("overflow", "visible");
            $(".btn-menu").addClass('_toggle');
            $(".__opened").css("display", "none");
            $(".__closed").css("display", "block");
            //$('.__icon').tooltip();
        }

        menu.lateral.click(function (e) {
            e.preventDefault();
            _this.manageMenu();
        });

        $(".open_sub").click(function () {
            if ($(this).hasClass("activ")) {
                $(this).removeClass("activ");
                $(".sub_menu").removeClass("sub-activ");
                $(".sub_menu").stop().slideUp();
            } else {
                $(".open_sub").removeClass("activ");
                $(this).addClass("activ");
                $(".sub_menu").removeClass("sub-activ");
                $(".sub_menu").slideUp();
                $(this).next(".sub_menu").stop().slideDown();
            }


        });

        $(document).on("mouseover", ".dropdown", function () {

            // if(menu._open===false){
            //     console.log("move false");
            //     $(this).find(".sub_menu").addClass("_open_mini");//css({"position":"absolute","z-index":"500"});
            //
            // }
            // $("#wrapper").removeClass("toggled");
            // menu._open = true;
            // $('.__icon').tooltip('destroy');
            // $(".btn-menu").removeAttr("style").removeClass('_toggle');
            // $(".__opened").css("display", "block");
            // $(".__closed").css("display", "none");
        });

        $(document).on("click", "._ss_title", function () {
            $(this).next(".__ss_menus").toggleClass("__open");
        });


        if ($("#wrapper").hasClass("toggled")) {
            $(".__opened").css("display", "none");
            $(".__closed").css("display", "block");
        } else {
            $(".__opened").css("display", "block");
            $(".__closed").css("display", "none");
        }

        // CHEK SI NAV OPENED
        if ($(".nav-active").length > 0) {
            var _parent = $(".nav-active").parent().data("section");
            if (_parent != undefined) {
                $(".nav-active").parent().addClass("__open");
                $(".__section_title[data-section=" + _parent + "]").addClass("__open");
            }
        }

        // CHECK SI DROP OPEN
        if ($(".ss-open").length > 0) {
            var _parent = $(".ss-open").parent().data("section");
            if (_parent != undefined) {
                $(".ss-open").parent().addClass("__open");
                $(".__section_title[data-section=" + _parent + "]").addClass("__open");
            }
        }

        $(document).on("click", ".__section_title", function () {
            var _section = $(this).data("section");


            $(".__section_title").not(this).removeClass("__open");
            $(this).toggleClass("__open");

            if ($(this).hasClass("__open")) {
                $(".open_sub").removeClass("activ");
                $(".sub_menu").slideUp();
                $(".__section[data-section=" + _section + "]").slideDown();
            } else {
                $(".__section[data-section=" + _section + "]").slideUp();
            }

            $(".__section[data-section!=" + _section + "]").slideUp();
        });


        $("#mdp_forget").click(function () {
            $(".alert-error").hide();
            $("#form_send_mail").show();
            $("#login_connexion").hide();
        });

        $(document).on("click", "._close_mdp", function () {
            $(".alert-error").hide();
            $("#form_send_mail").hide();
            $("#login_connexion").show();
        });

    }

    manageMenu(force) {


        if (force != undefined) {
            if (force === "open") {
                $("#wrapper").removeClass("toggled");
            } else {
                $("#wrapper").addClass("toggled");
            }
        } else {
            $("#wrapper").toggleClass("toggled");
        }
        if ($("#wrapper").hasClass("toggled")) {
            menu._open = false;
            $(".open_sub").removeClass("activ");
            $(".sub_menu").removeAttr("style");
            $("#sidebar-wrapper").css({"overflow": "visible"});
            $(".btn-menu").addClass('_toggle');
            $(".__opened").css("display", "none");
            $(".__closed").css("display", "block");
            //$('.__icon').tooltip();
        } else {
            menu._open = true;
            //$('.__icon').tooltip('destroy');
            $("#sidebar-wrapper").css({"overflow-x": "hidden", "overflow-y": "auto"});
            $(".btn-menu").removeAttr("style").removeClass('_toggle');
            $(".__opened").css("display", "block");
            $(".__closed").css("display", "none");
        }

        $.ajax({
            url: _URL + "/menu-state",
            data: {
                state: menu._open
            },
            type: "POST",
            context: document.body
        }).done(function (response) {
            return false;
        });
    }
}